import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = not authed, undefined = checking
  const [checking, setChecking] = useState(true);

  const fetchMe = useCallback(async (token) => {
    try {
      const { data } = await api.get("/auth/me", { headers: { Authorization: `Bearer ${token}` } });
      setUser(data);
      return data;
    } catch {
      setUser(null);
      localStorage.removeItem("hb_token");
      return null;
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("hb_token");
    if (!token) {
      setChecking(false);
      return;
    }
    fetchMe(token).finally(() => setChecking(false));
  }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("hb_token", data.access_token);
    api.defaults.headers.common.Authorization = `Bearer ${data.access_token}`;
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("hb_token");
    delete api.defaults.headers.common.Authorization;
    setUser(null);
  };

  // Always attach token if present
  useEffect(() => {
    const token = localStorage.getItem("hb_token");
    if (token) api.defaults.headers.common.Authorization = `Bearer ${token}`;
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, checking, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
